import $ from 'jquery';
import autosize from 'autosize';
import Swiper from 'swiper';
import 'owl.carousel';
import 'jquery-colorbox';
import 'ion-rangeslider';
import 'jquery-match-height';
import 'filterizr/dist/jquery.filterizr.min';
import cycle2 from '../../assets_c/js/cycle2.min';
import cycle2Swipe from '../../assets_c/js/cycle2.swipe.min';
import jsSocials from '../../assets_c/js/jssocials.min';
import {popup} from '../../components/popup/popup';
import {vrMessage} from '../../components/vrMessage/vrMessage';
import {exitPopup} from '../../components/exitPopup/exitPopup';
import {blogIndex} from '../../components/blogIndex/blogIndex';
import 'datatables.net-bs/js/dataTables.bootstrap.min';
import 'datatables.net-responsive-bs/js/responsive.bootstrap.min';

const appJS = () => {
	jsSocials();
	popup();
	vrMessage();
	exitPopup();
	blogIndex();
	
	let getLang = localStorage.getItem('lang'),
		lang = JSON.parse(getLang);
	
	// $(document).ready(function () {
	$(window).on("load", function () {
		let dataTables = $('.datatables-instructions');
		
		$('.js-no-event').click(function (e) {
			e.preventDefault();
		});
		
		$('#js-product-query').click(function (e) {
			e.preventDefault();
			let self = $(this);
			let form = $(self.data('form'));
			
			form.addClass('active');
		});
		
		$('.js-popup-contact-form-closer').click(function (e) {
			e.preventDefault();
			let self = $(this);
			let form = $(self.data('form'));
			
			form.removeClass('active');
		})
		
		let blCart = $('#js-bl-order');
		if (blCart.length == 1) {
			$.get(blCart.data('url'), function (data) {
				console.log(data);
			});
		}
		
		$(dataTables).DataTable({
			"paging": false,
			"ordering": false,
			"info": false,
			responsive: true,
			"language": {
				"zeroRecords": 'Zero records',
				"search": "",
			},
			initComplete: function () {
				this.api().column(1).every(function () {
					let column = this;
					let select = $('<select><option value="">' + lang['categories'] + '</option></select>')
						.appendTo($(column.header()))
						.on('change', function () {
							let val = $.fn.dataTable.util.escapeRegex(
								$(this).val()
							);
							
							column
								.search(val ? '^' + val + '$' : '', true, false)
								.draw();
						});
					
					column.data().unique().sort().each(function (d, j) {
						d = d.replace(/(<([^>]+)>)/ig, "");
						select.append('<option value="' + d + '">' + d + '</option>')
					});
				});
			}
		});
		
		$('#js-show-hide-all-accessories').click(function (e) {
			e.preventDefault();
			let self = $(this);
			let target = self.data('target');
			
			if (self.hasClass('active')) {
				$(target).addClass('hidden');
				self.removeClass('active');
			} else {
				$(target).removeClass('hidden');
				self.addClass('active');
			}
		});
		
		$('#js-architects-zone__tabs-list a').click(function () {
			var self = $(this);
			$('#js-architects-zone__tabs-list .current').removeClass('current');
			self.parent('li').addClass('current');
			
			filterArchitectZoneList(self.data('target'), self.data('parent'), self.data('form'));
		});
		
		var _changeInterval = null;
		
		$('#js-instructions__form input').on('keyup', function () {
			var self = $(this);
			let form = self.parent('div');
			clearInterval(_changeInterval)
			_changeInterval = setInterval(function () {
				filterArchitectZoneList(self.data('target'), self.data('parent'), self.data('form'));
				clearInterval(_changeInterval)
			}, 500);
			
			if (self.val() != '' && !form.hasClass('active')) {
				form.addClass('active');
			} else if (self.val() == '' || self.val() == undefined) {
				form.removeClass('active');
			}
		});
		
		function filterGlobal() {
			$(dataTables).DataTable().search(
				$('#global_filter').val(),
			).draw();
			
			let info = dataTables.DataTable();
			
			$('.showInfo').html(
				lang['page_instructions_search_result'] + ' ' + dataTables.DataTable().page.info().recordsDisplay + ' / ' + dataTables.DataTable().page.info().recordsTotal + ' ' + lang['page_instructions_search_instructions']
			);
		}
		
		function filterColumn(i) {
			$(dataTables).DataTable().column(i).search(
				$('#col' + i + '_filter').val(),
			).draw();
		}
		
		$('input.global_filter').on('keyup click', function () {
			filterGlobal();
		});
		
		$('input.column_filter').on('keyup click', function () {
			filterColumn($(this).parents('tr').attr('data-column'));
		});
		
		$(document).on("click", ".addtofav", (function (e) {
			e.preventDefault();
			let LINK = $(this);
			let productId = LINK.data('id');
			let productName = LINK.data('name');
			let link = `add-to-favorites,${productId},${productName}.html`;
			var product = $('#product-' + LINK.data('id'))
			var gtmData = {
				event: 'add_to_wishlist',
				ecommerce: {
					currency: product.data('currency'),
					value: product.data('price'),
					items: [{
						item_name: product.data('name'),
						item_id: product.data('id'),
						price: product.data('price'),
						item_category: product.data('category'),
						item_variant: product.data('variant'),
						index: product.data('index'),
						quantity: product.data('quantity')
					}]
				}
			};
			window.dataLayer = window.dataLayer || [];
			window.dataLayer.push(gtmData);
			
			// let TOOLTIP = $(LINK).find('.auto-tooltip');
			// alert(LINK.data('info'));
			$.ajax({
				url: link, success: function (data) {
					let response = JSON.parse(data);
					// TOOLTIP.html(TOOLTIP.data('msg'));
					// let TITLE = $('#fav-trigger a').data('title');
					// $('#fav-trigger > .favorite').attr('data-title', TITLE.replace('[[ILOSC]]', response.briefcaseCount));
					// $('#fav-trigger > .favorite').find('span').show().find('span.count').html(response.briefcaseCount);
					LINK.attr('title', LINK.data('fav-title'));
					LINK.addClass('added-fav');
					
					
					// location.reload();
				}
			});
			return false;
		}));
		
		function miniQuestion() {
			let miniQuestionWrapper = document.querySelector('.mini-question');
			let miniQuestion = document.querySelectorAll('.mini-question > span');
			
			miniQuestionWrapper.classList.add('mini-question--show');
			[...miniQuestion].forEach(item => {
				item.addEventListener('click', function (e) {
					e.preventDefault();
					
					if (item.dataset.question === 'Yes') {
						miniQuestionWrapper.classList.remove('mini-question--show');
						removeItem();
					} else if (item.dataset.question === 'No') {
						miniQuestionWrapper.classList.remove('mini-question--show');
					}
				});
			});
		}
		
		function removeItem() {
			let LINK = document.querySelector('.details-header__favorites');
			let productId = LINK.dataset.id;
			let productName = LINK.dataset.name;
			let link = `delete-from-favorites,${productId},${productName}.html`;
			
			$.get(link, function (data) {
				let response = JSON.parse(data);
				location.reload();
			});
		}
		
		function newRemoveFromFavorite() {
			let removeItemFromFav = document.querySelector('.new__removefromfav');
			
			if (removeItemFromFav) {
				removeItemFromFav.addEventListener('click', function (e) {
					e.preventDefault();
					
					let miniQuestionWrapper = document.querySelector('.mini-question');
					
					if (miniQuestionWrapper.classList.contains('mini-question--show')) {
						miniQuestionWrapper.classList.remove('mini-question--show');
					} else {
						miniQuestion();
					}
				});
			}
		}
		
		newRemoveFromFavorite();
		
		$(document).on("click", ".removefromfav", (function (e) {
			// $('.removefromfav').click(function (e) {
			e.preventDefault();
			let LINK = $(this);
			let productId = LINK.data('id');
			let productName = LINK.data('name');
			let link = `delete-from-favorites,${productId},${productName}.html`;
			
			// let r = confirm(LINK.data('question'));
			// if (miniQuestion() === true) {
			$.get(link, function (data) {
				$(LINK.data('target')).fadeOut(300);
				let response = JSON.parse(data);
				// let TITLE = $('#fav-trigger > .favorite').data('title');
				// $('#fav-trigger > .favorite').attr('data-title', TITLE.replace('[[ILOSC]]', response.briefcaseCount));
				// $('#fav-trigger > .favorite').find('span').show().find('.count').html(response.briefcaseCount);
				// let counter = $('#fav-trigger .favorite').find('span.count').text();
				//if (counter < 1) {
				location.reload();
				//}
			});
			// } else {
			// }
		}));
		
		$(".socials-share").jsSocials({
			showLabel: false,
			shares: ["email", "twitter", "facebook", "pinterest"]
		});
		
		$("a[href^='#section-']").click(function (e) {
			e.preventDefault();
			
			let position = $($(this).attr("href")).offset().top;
			
			$("body, html").animate({
				scrollTop: position - 200
			} /* speed */);
		});
		
		$("a[href^='#tab']").click(function (e) {
			e.preventDefault();
			
			let position = $($(this).attr("href")).offset().top;
			
			$("body, html").animate({
				scrollTop: position - 250
			} /* speed */);
		});
		
		// let filterizdItems = $('.inspiration-page-gallery__items');
		// if (filterizdItems && filterizdItems.length) {
		// 	let filterizd = filterizdItems.filterizr({});
		// 	filterizd.filterizr('setOptions', {
		// 		shuffle: true,
		// 		layout: 'sameSize',
		// 		delay: 350,
		// 		delayMode: 'alternate',
		// 		"filterOutCss": {
		// 			"opacity": 0,
		// 			"transform": "scale(0.75)"
		// 		},
		// 		"filterInCss": {
		// 			"opacity": 1,
		// 			"transform": "scale(1)"
		// 		}
		// 	});
		// 	$('.inspiration-page-gallery__nav ul li').click(function () {
		// 		$('.inspiration-page-gallery__nav ul li').removeClass('active');
		// 		$(this).addClass('active');
		// 	});
		// }
		
		$('.inspiration-page-gallery__nav ul li').click(function (e) {
			e.preventDefault();
			var self = $(this);
			$('.inspiration-page-gallery__nav ul li').removeClass('active');
			self.addClass('active');
			
			$('a.inspiration-item.js-cat-all a').colorbox.remove();
			$(self.data('target') + ' .js-cat-all').addClass('hidden');
			$(self.data('target') + ' ' + self.data('filter')).removeClass('hidden');
			// inspirationColorboxInit($(self.data('target') + ' ' + self.data('filter') + ' a'));
		});
		
		
		let pageTitle = $("title").text();
		
		// $(window).blur(function () {
		// 	$("title").text("Nortberg");
		// });
		
		$(window).focus(function () {
			$("title").text(pageTitle);
		});
		
		autosize($('textarea'));
		autosize.destroy($('.review-form__inner .form-group textarea'));
		
		cycle2();
		cycle2Swipe();
		
		initStickyHeader();
		initHomeSlider();
		initSaloonCarousel();
		initPopularCarousel();
		initAccordion();
		initInstructionsList();
		initInputNumberType();
		initColorbox();
		initArchitectSlider();
		initDetailsSlider();
		initCartView();
		initGlobalSearch();
		initMoreText();
		initRangeSlider();
		initSubMenu();
		// initExendedGallery();
		initMatchHeight();
		initTabs();
		initFilters();
		initOpinions();
		initMobileMenu();
		readMore();
		// initLightbox();
	});
	
	function readMore() {
		$('.longText.d1 > span.showMore').on('click', function (e) {
			e.preventDefault();
			
			$('.d1 label').removeClass('hideLongText');
			$(this).remove();
		});
		
		$('.longText.d2 > span.showMore').on('click', function (e) {
			e.preventDefault();
			
			$('.d2 label').removeClass('hideLongText');
			$(this).remove();
		});
		
		$('.longText.d3 > span.showMore').on('click', function (e) {
			e.preventDefault();
			
			$('.d3 label').removeClass('hideLongText');
			$(this).remove();
		});
	}
	
	function initStickyHeader() {
		
		let menu = document.querySelector('.header');
		if (menu) {
			let origOffsetY = menu.offsetTop;
			let lang = document.documentElement.lang;
			let w = window.innerWidth;
			
			function scroll() {
				if ($(window).scrollTop() > origOffsetY) {
					if (lang === 'no' && w >= 768) {
						$('.top').removeClass('certificates-wrapper');
						$('.header').removeClass('certificates-wrapper');
						$('.certificates').removeClass('show-cert');
					}
					$('.header').addClass('scrolling');
				} else {
					if (lang === 'no' && w >= 768) {
						$('.top').addClass('certificates-wrapper');
						$('.certificates').addClass('show-cert');
						$('.header').addClass('certificates-wrapper');
					}
					$('.header').removeClass('scrolling');
				}
			}
			
			scroll();
			document.onscroll = scroll;
		}
		
	}
	
	function initHomeSlider() {
		
		var homepageSwiper = new Swiper('.home-slider',
			{
				loop: true,
				speed: 900,
				parallax: true,
				autoplay: {
					delay: 2500,
					disableOnInteraction: false,
				},
				navigation: {
					nextEl: '.home-slider__button--next',
					prevEl: '.home-slider__button--prev'
				}
			}
		);
		
		/* pause on hover */
		$('.swiper-container').hover(function () {
			this.swiper.autoplay.stop();
		}, function () {
			this.swiper.autoplay.start();
		});
		
	}
	
	let initSaloonCarousel = () => {
		if ($('.js-saloon-swiper')) {
			var saloonSwiper = new Swiper('.js-saloon-swiper',
				{
					loop: true,
					speed: 900,
					slidesPerView: 1,
					
					autoplay: {
						delay: 2500,
						disableOnInteraction: false,
					}
				}
			);
		}
	}
	
	let initPopularCarousel = () => {
		let $owl = $(".popular-carousel").owlCarousel({
			items: 3,
			margin: 75,
			navContainer: '#popular-owl-nav',
			navText: ['<img src="themes/nortberg/assets_c/images/home-slider--arrow-left--white.svg">', '<img src="themes/nortberg/assets_c/images/home-slider--arrow-right--white.svg">'],
			responsive: {
				1601: {
					items: 3,
					margin: 75,
				},
				1367: {
					items: 3,
					margin: 60
				},
				769: {
					items: 3,
					margin: 30
				},
				501: {
					items: 2,
					margin: 30
				},
				0: {
					items: 1,
					margin: 0
				}
			}
		});
		
		return $owl;
	};
	
	function initAccordion() {
		
		$('.accordion-list__header').on('click', function (e) {
			e.preventDefault();
			let self = $(this);
			let parent = self.parent('.architect-item');
			let menuHeight = $('#js-new-header').height();
			
			
			if (parent.hasClass('active')) {
				parent.removeClass('active').find('.architect-item__content').slideUp(300);
			} else {
				$('.accordion-list__item').removeClass('active');
				$('.architect-item__content').slideUp(300);
				parent.addClass('active').find('.architect-item__content').slideDown(300);
				setTimeout(() => {
					$([document.documentElement, document.body]).animate({
						scrollTop: $(self.data('target')).offset().top - menuHeight
					}, 500);
				}, 350);
			}
			
			
		});
		
	}
	
	function initInstructionsList() {
		
		$('.instructions-col__title').on('click', function () {
			$(this).stop(true, true).toggleClass('active');
			$(this).parent().find('.instructions-col__list').stop(true, true).slideToggle();
		});
		
	}
	
	function initInputNumberType() {
		
		$('.product-count').each(function () {
			var spinner = $(this),
				input = spinner.find('input[type="number"]'),
				btnUp = spinner.find('.product-count__button--up'),
				btnDown = spinner.find('.product-count__button--down'),
				min = input.attr('min'),
				max = input.attr('max');
			btnUp.click(function () {
				var oldValue = parseFloat(input.val());
				if (oldValue >= max) {
					var newVal = oldValue;
				} else {
					var newVal = oldValue + 1;
				}
				spinner.find("input").val(newVal);
				spinner.find("input").trigger("change");
			});
			btnDown.click(function () {
				var oldValue = parseFloat(input.val());
				if (oldValue <= min) {
					var newVal = oldValue;
				} else {
					var newVal = oldValue - 1;
				}
				spinner.find("input").val(newVal);
				spinner.find("input").trigger("change");
			});
		});
		
	}
	
	function initColorbox() {
		
		// inspirationColorboxInit($('a.inspiration-item'));
		
		// $('.js-colorbox').colorbox({
		// 	maxWidth: '95%',
		// 	maxHeight: '95%',
		// 	scrolling: false,
		// 	fixed: true,
		// 	title: ''
		// });
		
		// $('a.gallery-item').colorbox({
		// 	rel: 'photogallery',
		// 	maxWidth: '95%',
		// 	maxHeight: '95%',
		// 	scrolling: false,
		// 	fixed: true,
		// 	title: '',
		// 	onClosed: function (e) {
		// 		console.log(e);
		// 		return false;
		// 	}
		// });
		
		// $('a.other-gallery-item').colorbox({
		// 	rel: 'other-photogallery',
		// 	maxWidth: '95%',
		// 	maxHeight: '95%',
		// 	scrolling: false,
		// 	fixed: true,
		// 	title: ''
		// });
		
		$('a.js-movie-popup').colorbox({
			iframe: true,
			innerWidth: 1000,
			innerHeight: 564,
			maxWidth: '95%',
			maxHeight: '95%',
			title: ''
		});
		
		$('.js-video-popup').click(function (e) {
			e.preventDefault();
			var self = $(this);
			
			$('body').append('<div class="video-component">' +
				'<div class="video-component__overlay video-component-closer"></div>' +
				'<div class="video-component__video">' +
				'<div class="video-component__close video-component-closer"></div>' +
				'<video src="' + self.data('video') + '" controls preload autoplay></video>' +
				'</div>' +
				'</div>');
		});
		
		$('body').on('click', '.video-component-closer', function (e) {
			e.preventDefault();
			var self = $(this);
			
			$('.video-component').remove();
		});
		
		// $('a.js-video-popup').each(function () {
		// 	var item = $(this);
		// 	var href = item.attr('href');
		// 	item.colorbox({
		// 		inline: true,
		// 		href: '#video',
		// 		innerWidth: 1000,
		// 		innerHeight: 564,
		// 		maxWidth: '95%',
		// 		maxHeight: '95%',
		// 		title: ''
		// 	});
		// });
		
		$('a.show-movie-play').colorbox({
			iframe: true,
			innerWidth: 1000,
			innerHeight: 564,
			maxWidth: '95%',
			maxHeight: '95%',
			title: ''
		});
		
	}
	
	function initArchitectSlider() {
		
		var architectSwiper = new Swiper('.hero-slider__container',
			{
				loop: true,
				speed: 900,
				navigation: {
					nextEl: '.hero-slider__button--next',
					prevEl: '.hero-slider__button--prev'
				}
			}
		);
		
	}
	
	function initDetailsSlider() {
		
		var detailsSwiper = new Swiper('.details-slider',
			{
				loop: false,
				speed: 900,
				navigation: {
					nextEl: '.details-slider__button--next',
					prevEl: '.details-slider__button--prev'
				},
			}
		);
		
	}
	
	function initCartView() {
		let smallCart = document.querySelector('#smallCart');
		
		// if (smallCart) {
		// 	$(smallCart).hover(function () {
		// 		$(smallCart).toggleClass('showCart');
		// 	});
		// }
		
		
		// _header.scss 616:621, 666:668, 670:673
		// var itemClick = '#smallCart';
		// var iconBadge = '.small-cart__badge';
		// var itemShow = '.options__small-cart .small-cart__view';
		// $(itemClick).hover(function () {
		// 	// console.log('test 1');
		// 	$(itemShow).fadeToggle();
		// });
		// $(iconBadge).hover(function () {
		// 	// console.log('test');
		// 	$(itemShow).fadeToggle();
		// });
		// $(document).hover(function (e) {
		// 	if ($(e.target).closest('.options__small-cart').length || $(e.target).hasClass('.options__small-cart')) return;
		// 	$(itemShow).fadeOut();
		// });
	}
	
	function initGlobalSearch() {
		var itemOpen = '#globalSearch';
		var itemShow = '.global-search';
		var itemClose = '.global-search__close';
		$(itemOpen).on('click', function () {
			$(itemShow).stop(true, true).fadeIn();
		});
		$(itemClose).on('click', function () {
			$(itemShow).stop(true, true).fadeOut();
		});
		
	}
	
	function initMoreText() {
		
		$('.list-description__more').on('click', function () {
			$(this).stop(true, true).toggleClass('active');
			$('.cms_content--smaller').toggleClass('cms_content--homepage');
			// $('.cms_content--smaller').stop(true, true).removeClass('cms_content--homepage');
			$('.list-description__content').toggleClass('active');
			// $('.list-description__content').stop(true, true).toggleClass('active');
			$('.list-description__content .more-text').toggle().slideDown();
			// $('.list-description__content .more-text').stop(true, true).slideDown();
		});
		
	}
	
	function initRangeSlider() {
		
		$(".price-range-slider").ionRangeSlider({
			type: "double",
			min: 300,
			max: 1500,
			// from: 550,
			// to: 1200,
			// postfix: ' PLN'
		});
		
	}
	
	function toggleMenu(event, parent, submenu, className) {
		parent.addEventListener(event, (e) => {
			e.preventDefault();
			
			if (event === 'mouseenter') {
				submenu.classList.add(className);
			} else {
				submenu.classList.remove(className);
			}
		});
	}
	
	function initSubMenu() {
		let w = window.innerWidth;
		let h = window.innerHeight;
		
		let menuParents = document.querySelectorAll('.main-menu__item--parent');
		
		[...menuParents].forEach(parent => {
			let events = ['mouseenter', 'mouseleave'];
			let submenu = parent.querySelector('.main-menu__submenu');
			
			events.forEach(eventName => {
				parent.addEventListener(eventName, e => {
					e.preventDefault();
					
					// if (eventName === "mouseenter") {
					toggleMenu(eventName, parent, submenu, 'main-menu__submenu--show')
					// }
				});
			});
		});
		
		// $('.main-menu__item--parent').hover(function () {
		// 	if (w >= 1600) {
		// 		$('.main-menu__submenu').stop(true, true).css("display", "flex");
		// 	} else {
		// 		$('.main-menu__submenu').stop(true, true).css("display", "block");
		// 	}
		//
		// }, function () {
		// 	$('.main-menu__submenu').stop(true, true).delay(300).slideUp(300);
		// });
		
	}
	
	function initExendedGallery() {
		
		// $('.show-gallery').on('click', function () {
		// 	$('.gallery-popup').fadeIn(300);
		// });
		
		// $('.JS_product-details__arrangements-btn-gallery').on('click', function (e) {
		// 	e.preventDefault();
		//
		// 	var el = $('.about-gallery__link.gallery-item');
		//
		// 	if (el[0]) {
		// 		$('a[rel="arrangements"]').colorbox({
		// 			rel: 'arrangements',
		// 			maxWidth: '95%',
		// 			maxHeight: '95%',
		// 			scrolling: false,
		// 			fixed: true,
		// 			title: '',
		// 			open: true,
		// 			returnFocus: false
		// 		});
		// 	}
		// });
		
		// $('.gallery-popup .gallery-popup__close').on('click', function () {
		// 	$('.gallery-popup').fadeOut(300);
		// });
		
		$('.gallery-popup__carousel').owlCarousel({
			items: 12,
			margin: 10,
			loop: false,
			center: false,
			dots: false,
			nav: true,
			navText: ['<img src="themes/nortberg/assets_c/images/home-slider--arrow-left--white.svg">', '<img src="themes/nortberg/assets_c/images/home-slider--arrow-right--white.svg">'],
			mouseDrag: false,
			touchDrag: false,
			autoplayHoverPause: true,
			responsive: {
				1601: {
					items: 12
				},
				1367: {
					items: 10
				},
				769: {
					items: 6
				},
				0: {
					items: 3
				}
			}
		});
		
		$('.gallery-popup__slider').cycle({
			speed: 600,
			slides: '> .slide',
			prev: '.gallery-popup__carousel .owl-nav .owl-prev',
			next: '.gallery-popup__carousel .owl-nav .owl-next',
			swipe: false,
			loop: 1,
		});
		
	}
	
	function initMatchHeight() {
		
		$('.match-height').matchHeight();
		
	}
	
	function initTabs() {
		
		$('#map path').on('click', function (e) {
			var
				id = e.target.getAttribute('id'),
				IDName = e.target.getAttribute('data-voivodeship'),
				Name = document.getElementById("VoivodeshipsName")
			;
			
			Name.innerHTML = IDName;
			if (!id.length) return;
			$('.tabs__content.active').removeClass('active');
			$(`.tabs__content[data-id=${id}]`).addClass('active');
			$('.pin.active').removeClass('active');
			$(`.pin--${id}`).addClass('active');
			$('#map path.active').removeClass('active');
			$(`#${id}`).addClass('active');
		});
	}
	
	function initFilters() {
		$('.js-filter-header').click(function (e) {
			e.preventDefault();
			var self = $(this);
			var target = $(self.data('target'));
			target.slideToggle();
			self.toggleClass('active');
		})
		
		$('.js-clear-radio-selection').click(function (e) {
			e.preventDefault();
			var self = $(this);
			self.parent('label').find('input').prop('checked', false);
		})
		
		$('#js-filters-trigger').on('click', function () {
			$(this).toggleClass('active');
			$(this).next().slideToggle(400);
			if ($(this).hasClass('active')) {
				$(this).text(lang['products_list_filters_hide']);
			} else {
				$(this).text(lang['products_list_filters']);
			}
		});
		// console.log(localStorage.getItem('lang'));
		
	}
	
	function initOpinions() {
		// $('.details-header__see-reviews').on('click', function (e) {
		// 	e.preventDefault();
		// 	let mainMenuHeight = $('#JS__main-menu').outerHeight();
		//
		// 	$('html, body').animate({
		// 		scrollTop: $($(this).attr('href')).offset().top - mainMenuHeight,
		// 	}, 600);
		// });
	}
	
	function initMobileMenu() {
		
		$('.header__trigger').on('click', function () {
			$('.mobile-menu').addClass('menu-visible');
		});
		$('.mobile-menu__close').on('click', function () {
			$('.mobile-menu').removeClass('menu-visible');
		});
		
		$('.mobile-menu__list li.items > a').on('click', function (e) {
			e.preventDefault();
			$(this).toggleClass('active');
			$(this).next().slideToggle(300);
		});
		
	}
	
	
	return {
		initPopularCarousel: initPopularCarousel
	}
};

export default appJS;


function filterArchitectZoneList(itemsList, parent, form) {
	$(itemsList + ' .js-product-list-item').hide();
	let current = $(parent + ' .current > a');
	$(itemsList + ' ' + current.data('class')).show();
	
	let phrase = ($(form + ' input').val()).toLowerCase();
	if (phrase != '' && phrase != undefined) {
		let phrases = phrase.split(' ');
		$(itemsList + ' ' + current.data('class')).each(function () {
			let item = $(this);
			let x = 0;
			let tags = (item.data('tags')).toLowerCase();
			// for (let i = 0; i <= phrases.length; i++) {
			// 	if (phrases[i] != '' && phrases[i] != undefined) {
			if (tags.indexOf(phrase) != -1) {
				x++;
			}
			// }
			// }
			if (x == 0) {
				item.hide();
			} else {
				item.show();
			}
		});
	}
}

function inspirationColorboxInit(element) {
	element.colorbox({
		rel: 'inspiration-gallery',
		maxWidth: '97%',
		maxHeight: '97%',
		scrolling: false,
		fixed: true,
		title: function () {
			var name = $(this).attr('title');
			var url = $(this).data('url');
			
			var information = $(this).data('information');
			var buynow = $(this).data('buynow');
			
			$('body').addClass('colorbox-w-title');
			return '<span class="title">' + name + '</span><span class="inspiration-buttons">' +
				'<a class="inspiration-buttons__view" href="' + url + '" target="_blank">' + information + '</a> ' +
				'<a class="inspiration-buttons__buy" href="' + url + '" target="_blank">' + buynow + '</a></span>';
		}
	});
}

$(function () {
	newInitStickyHeader();
	newInitMegaMenuImage();
	newInitMobileMenu();
	newInitMobileMegaMenu();
	initCartPopup();
});

function newInitStickyHeader() {
	var menu = document.querySelector('.new-header');
	var origOffsetY = menu.offsetTop;
	
	function scroll() {
		if ($(window).scrollTop() > origOffsetY) {
			$('.new-header').addClass('scrolling');
			$('.new-mega-menu').addClass('scrolling');
		} else {
			$('.new-header').removeClass('scrolling');
			$('.new-mega-menu').removeClass('scrolling');
		}
	}
	
	scroll();
	
	document.onscroll = scroll;
}

function newInitMegaMenuImage() {
	$('.new-mega-menu__smallList li a, .new-mega-menu__largeList li a').mouseover(function () {
		var img = $(this).data('img');
		
		$('.new-mega-menu__col--image').css('background-image', 'url("' + img + '")');
	});
}

function newInitMobileMenu() {
	$('.new-header__trigger').on('click', function () {
		$('.new-mobile-menu').addClass('visible');
	});
	
	$('.new-mobile-menu__close').on('click', function () {
		$('.new-mobile-menu').removeClass('visible');
	});
}

function newInitMobileMegaMenu() {
	$('.new-mobile-menu__nav .nav__list .list__item a[data-id]').on('click', function (e) {
		e.preventDefault();
		
		var dataId = $(this).data('id');
		
		$('#' + dataId).addClass('active');
	});
	
	$('.new-mega-menu__back').on('click', function () {
		$(this).closest('.new-mega-menu--mobile').removeClass('active');
	});
}

function initCartPopup() {
	var leaveCartPopup = document.querySelector('.leaveCartPopup');
	var leaveCartPopupContent = document.querySelector('.leaveCartPopup__content');
	var leaveCartPopupClose = document.querySelectorAll('.JS-close-leaveCartPopup');
	
	if (leaveCartPopup) {
		leaveCartPopupClose.forEach(function (close) {
			close.addEventListener('click', function () {
				var in60Minutes = 1 / 24;
				
				sessionStorage.setItem('leaveCartPopup', '1');
				
				leaveCartPopup.classList.remove('active');
			});
		});
		
		leaveCartPopupContent.addEventListener('click', function (e) {
			e.stopPropagation();
		});
		
		if (sessionStorage.getItem('leaveCartPopup')) {
			leaveCartPopup.classList.remove('active');
		} else {
			leaveCartPopup.classList.add('active');
		}
	}
}




// WEBPACK FOOTER //
// ../assets_c/js/app.js